// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"8507d057","910":"f4eedbf0"}[chunkId] + ".chunk.css";
};